import { Button, BUTTON_VARIANTS, CheckBox, Layout, Toast, Typography } from '@community_dev/pixels'
import { ReactNode, useState, type JSX } from 'react'
import { useTheme } from 'styled-components'

import { StyledLink } from 'screens/LoginScreen/LoginScreen.style'

export type TcpaTermsProps = {
  text: string
  onAccept: () => unknown
  error?: ReactNode
}

export function TcpaTerms({ text, error, onAccept }: TcpaTermsProps): JSX.Element {
  const { COLORS } = useTheme() || {}
  const [isLegalCheckboxChecked, setIsLegalCheckboxChecked] = useState(false)
  return (
    <>
      {error && <Toast icon maxWidth="100%" message={error} success={false} />}
      <Typography variant="h1">Terms & Conditions</Typography>
      <Layout
        alignItems="start"
        as="label"
        background={COLORS.APP_BACKGROUND_LEVEL_3}
        border={`1px solid ${COLORS.LINKS}`}
        borderRadius="8px"
        display="flex"
        flexDirection="row"
        marginBottom="24px"
        padding="16px"
      >
        <CheckBox
          onChange={(value) => setIsLegalCheckboxChecked(value)}
          selected={isLegalCheckboxChecked}
          style={{ marginTop: '4px', marginRight: '16px' }}
        />
        <Typography marginTop={0} variant="body2">
          {text}
          <Layout marginTop="8px">
            For more information, see our{' '}
            <StyledLink href="https://www.community.com/legal/privacy-policy" target="_blank">
              Privacy Policy
            </StyledLink>{' '}
            and{' '}
            <StyledLink href="https://www.community.com/legal/customer-terms" target="_blank">
              Terms of Use
            </StyledLink>
            .
          </Layout>
        </Typography>
      </Layout>
      <Button
        disabled={isLegalCheckboxChecked === false}
        onClick={onAccept}
        style={{ maxWidth: '100%' }}
        variant={BUTTON_VARIANTS.ACTION}
      >
        Continue
      </Button>
    </>
  )
}
